import { Column } from '~/commonComponents';
import { IDraftJobPostEntity } from '~/domain/PermanentJobs';
import { formatBenefits, formatPayRange, formatPayTitle } from '../../utils/formatters';
import { InfoSection } from '../InfoSection';
import { LabelValueDisplay } from '../LabelValueDisplay';

interface IEarningsBenefitsPreviewProps {
  jobPosting: IDraftJobPostEntity;
  onEditClick: () => void;
}

export const EarningsBenefitsPreview = ({
  jobPosting,
  onEditClick,
}: IEarningsBenefitsPreviewProps) => {
  return (
    <InfoSection
      icon="money-pay-solid"
      rightActionIcon="edit-pencil"
      title="Earnings and Benefits"
      onRightActionPress={onEditClick}
    >
      <Column gap={14}>
        <LabelValueDisplay label="Pay Type" value={jobPosting.payType} />
        <LabelValueDisplay
          label={formatPayTitle(jobPosting.minRate, jobPosting.maxRate)}
          value={formatPayRange(jobPosting.minRate, jobPosting.maxRate, jobPosting.payType)}
        />
        <LabelValueDisplay label="Benefits" value={formatBenefits(jobPosting.benefits || [])} />
        {jobPosting.benefitsOther && (
          <LabelValueDisplay label="Other Benefits" value={jobPosting.benefitsOther} />
        )}
      </Column>
    </InfoSection>
  );
};
